import { t } from '../../../../../../infra/i18n';
import { i18n } from '../../../../../../infra/i18n/i18n';
export var oneTimeSchema = {
    time: {
        display: true,
        required: true,
        disabled: false,
    },
    sendDate: {
        display: true,
        required: true,
        disabled: false,
    },
    endDate: {
        display: true,
        required: false,
        disabled: true,
    },
    dayOfWeek: {
        display: false,
    },
    dayOfMonth: {
        display: false,
    },
};
export var weeklySchema = {
    time: {
        display: true,
        required: true,
        disabled: false,
    },
    sendDate: {
        display: false,
    },
    endDate: {
        display: true,
        required: false,
        disabled: false,
    },
    dayOfWeek: {
        display: true,
        required: true,
        disabled: false,
    },
    dayOfMonth: {
        display: false,
    },
};
export var biWeeklySchema = weeklySchema;
export var monthlySchema = {
    time: {
        display: true,
        required: true,
        disabled: false,
    },
    sendDate: {
        display: false,
    },
    endDate: {
        display: true,
        required: false,
    },
    dayOfWeek: {
        display: false,
    },
    dayOfMonth: {
        display: true,
        required: true,
    },
};
export var inputSchemas = {
    'one-time': oneTimeSchema,
    weekly: weeklySchema,
    'bi-weekly': biWeeklySchema,
    monthly: monthlySchema,
};
export var getTimeOptions = function () { return [
    {
        label: t('engage:campaign_builder.timeline.time_format', {
            hour: 12,
            period: t('engage:campaign_builder.timeline.am'),
        }),
        value: '00:00',
    },
    {
        label: t('engage:campaign_builder.timeline.time_format', {
            hour: 1,
            period: t('engage:campaign_builder.timeline.am'),
        }),
        value: '01:00',
    },
    {
        label: t('engage:campaign_builder.timeline.time_format', {
            hour: 2,
            period: t('engage:campaign_builder.timeline.am'),
        }),
        value: '02:00',
    },
    {
        label: t('engage:campaign_builder.timeline.time_format', {
            hour: 3,
            period: t('engage:campaign_builder.timeline.am'),
        }),
        value: '03:00',
    },
    {
        label: t('engage:campaign_builder.timeline.time_format', {
            hour: 4,
            period: t('engage:campaign_builder.timeline.am'),
        }),
        value: '04:00',
    },
    {
        label: t('engage:campaign_builder.timeline.time_format', {
            hour: 5,
            period: t('engage:campaign_builder.timeline.am'),
        }),
        value: '05:00',
    },
    {
        label: t('engage:campaign_builder.timeline.time_format', {
            hour: 6,
            period: t('engage:campaign_builder.timeline.am'),
        }),
        value: '06:00',
    },
    {
        label: t('engage:campaign_builder.timeline.time_format', {
            hour: 7,
            period: t('engage:campaign_builder.timeline.am'),
        }),
        value: '07:00',
    },
    {
        label: t('engage:campaign_builder.timeline.time_format', {
            hour: 8,
            period: t('engage:campaign_builder.timeline.am'),
        }),
        value: '08:00',
    },
    {
        label: t('engage:campaign_builder.timeline.time_format', {
            hour: 9,
            period: t('engage:campaign_builder.timeline.am'),
        }),
        value: '09:00',
    },
    {
        label: t('engage:campaign_builder.timeline.time_format', {
            hour: 10,
            period: t('engage:campaign_builder.timeline.am'),
        }),
        value: '10:00',
    },
    {
        label: t('engage:campaign_builder.timeline.time_format', {
            hour: 11,
            period: t('engage:campaign_builder.timeline.am'),
        }),
        value: '11:00',
    },
    {
        label: t('engage:campaign_builder.timeline.time_format', {
            hour: 12,
            period: t('engage:campaign_builder.timeline.pm'),
        }),
        value: '12:00',
    },
    {
        label: t('engage:campaign_builder.timeline.time_format', {
            hour: 1,
            period: t('engage:campaign_builder.timeline.pm'),
        }),
        value: '13:00',
    },
    {
        label: t('engage:campaign_builder.timeline.time_format', {
            hour: 2,
            period: t('engage:campaign_builder.timeline.pm'),
        }),
        value: '14:00',
    },
    {
        label: t('engage:campaign_builder.timeline.time_format', {
            hour: 3,
            period: t('engage:campaign_builder.timeline.pm'),
        }),
        value: '15:00',
    },
    {
        label: t('engage:campaign_builder.timeline.time_format', {
            hour: 4,
            period: t('engage:campaign_builder.timeline.pm'),
        }),
        value: '16:00',
    },
    {
        label: t('engage:campaign_builder.timeline.time_format', {
            hour: 5,
            period: t('engage:campaign_builder.timeline.pm'),
        }),
        value: '17:00',
    },
    {
        label: t('engage:campaign_builder.timeline.time_format', {
            hour: 6,
            period: t('engage:campaign_builder.timeline.pm'),
        }),
        value: '18:00',
    },
    {
        label: t('engage:campaign_builder.timeline.time_format', {
            hour: 7,
            period: t('engage:campaign_builder.timeline.pm'),
        }),
        value: '19:00',
    },
    {
        label: t('engage:campaign_builder.timeline.time_format', {
            hour: 8,
            period: t('engage:campaign_builder.timeline.pm'),
        }),
        value: '20:00',
    },
    {
        label: t('engage:campaign_builder.timeline.time_format', {
            hour: 9,
            period: t('engage:campaign_builder.timeline.pm'),
        }),
        value: '21:00',
    },
    {
        label: t('engage:campaign_builder.timeline.time_format', {
            hour: 10,
            period: t('engage:campaign_builder.timeline.pm'),
        }),
        value: '22:00',
    },
    {
        label: t('engage:campaign_builder.timeline.time_format', {
            hour: 11,
            period: t('engage:campaign_builder.timeline.pm'),
        }),
        value: '23:00',
    },
]; };
export var getDayOfWeekOptions = function () { return [
    { label: t('engage:campaign_builder.timeline.days.sunday'), value: 'SU' },
    { label: t('engage:campaign_builder.timeline.days.monday'), value: 'MO' },
    { label: t('engage:campaign_builder.timeline.days.tuesday'), value: 'TU' },
    { label: t('engage:campaign_builder.timeline.days.wednesday'), value: 'WE' },
    { label: t('engage:campaign_builder.timeline.days.thursday'), value: 'TH' },
    { label: t('engage:campaign_builder.timeline.days.friday'), value: 'FR' },
    { label: t('engage:campaign_builder.timeline.days.saturday'), value: 'SA' },
]; };
var getEnglishOrdinalSuffix = function (num) {
    if (num >= 11 && num <= 13) {
        return 'th';
    }
    switch (num % 10) {
        case 1:
            return 'st';
        case 2:
            return 'nd';
        case 3:
            return 'rd';
        default:
            return 'th';
    }
};
var getSpanishOrdinalSuffix = function (num) {
    switch (num) {
        case 1:
        case 3:
            return 'ro';
        case 2:
            return 'do';
        case 4:
        case 5:
        case 6:
            return 'to';
        case 7:
        case 10:
            return 'mo';
        case 8:
        case 11:
        case 12:
        case 13:
        case 14:
        case 15:
        case 16:
        case 17:
        case 18:
        case 19:
        case 20:
        case 21:
        case 22:
        case 23:
        case 24:
        case 25:
        case 26:
        case 27:
        case 28:
            return 'vo';
        case 9:
            return 'no';
        default:
            return 'vo';
    }
};
var getOrdinalSuffix = function (num) {
    var currentLanguage = i18n.language;
    return currentLanguage === 'es' ? getSpanishOrdinalSuffix(num) : getEnglishOrdinalSuffix(num);
};
export var getDayOfMonthOptions = function () {
    var options = [];
    for (var i = 1; i <= 28; i += 1) {
        var suffix = getOrdinalSuffix(i);
        options.push({
            label: t('engage:campaign_builder.timeline.ordinal_format', { number: i, suffix: suffix }),
            value: i.toString(),
        });
    }
    // Add "or last day" options for 29, 30, 31
    for (var i = 29; i <= 31; i += 1) {
        var suffix = getOrdinalSuffix(i);
        options.push({
            label: t('engage:campaign_builder.timeline.ordinal_or_last', { number: i, suffix: suffix }),
            value: i.toString(),
        });
    }
    return options;
};
export var CampaignSchedule;
(function (CampaignSchedule) {
    CampaignSchedule["ONE_TIME"] = "one-time";
    CampaignSchedule["WEEKLY"] = "weekly";
    CampaignSchedule["BI_WEEKLY"] = "bi-weekly";
    CampaignSchedule["MONTHLY"] = "monthly";
})(CampaignSchedule || (CampaignSchedule = {}));
export var getSchedulingOptions = function () { return [
    { label: t('engage:campaign_builder.timeline.schedule.one_time'), value: CampaignSchedule.ONE_TIME },
    { label: t('engage:campaign_builder.timeline.schedule.weekly'), value: CampaignSchedule.WEEKLY },
    { label: t('engage:campaign_builder.timeline.schedule.every_2_weeks'), value: CampaignSchedule.BI_WEEKLY },
    { label: t('engage:campaign_builder.timeline.schedule.monthly'), value: CampaignSchedule.MONTHLY },
]; };
export var getActiveOption = function (value, options) {
    return options.find(function (option) { return option.value === value; });
};
